export default "__VITE_ASSET__BSW_tqry__"